// ISO 4217 currency codes with human-readable names.
// value = 3-letter code, label shows "CODE — Name".
export const CURRENCIES = [
  ["ZAR", "South African Rand"], ["USD", "US Dollar"], ["EUR", "Euro"],
  ["GBP", "British Pound"], ["AUD", "Australian Dollar"], ["CAD", "Canadian Dollar"],
  ["AED", "UAE Dirham"], ["AFN", "Afghan Afghani"], ["ALL", "Albanian Lek"],
  ["AMD", "Armenian Dram"], ["ANG", "Netherlands Antillean Guilder"], ["AOA", "Angolan Kwanza"],
  ["ARS", "Argentine Peso"], ["AWG", "Aruban Florin"], ["AZN", "Azerbaijani Manat"],
  ["BAM", "Bosnia-Herzegovina Convertible Mark"], ["BBD", "Barbadian Dollar"], ["BDT", "Bangladeshi Taka"],
  ["BGN", "Bulgarian Lev"], ["BHD", "Bahraini Dinar"], ["BIF", "Burundian Franc"],
  ["BMD", "Bermudian Dollar"], ["BND", "Brunei Dollar"], ["BOB", "Bolivian Boliviano"],
  ["BRL", "Brazilian Real"], ["BSD", "Bahamian Dollar"], ["BTN", "Bhutanese Ngultrum"],
  ["BWP", "Botswana Pula"], ["BYN", "Belarusian Ruble"], ["BZD", "Belize Dollar"],
  ["CDF", "Congolese Franc"], ["CHF", "Swiss Franc"], ["CLP", "Chilean Peso"],
  ["CNY", "Chinese Yuan"], ["COP", "Colombian Peso"], ["CRC", "Costa Rican Colón"],
  ["CUP", "Cuban Peso"], ["CVE", "Cape Verdean Escudo"], ["CZK", "Czech Koruna"],
  ["DJF", "Djiboutian Franc"], ["DKK", "Danish Krone"], ["DOP", "Dominican Peso"],
  ["DZD", "Algerian Dinar"], ["EGP", "Egyptian Pound"], ["ERN", "Eritrean Nakfa"],
  ["ETB", "Ethiopian Birr"], ["FJD", "Fijian Dollar"], ["FKP", "Falkland Islands Pound"],
  ["GEL", "Georgian Lari"], ["GHS", "Ghanaian Cedi"], ["GIP", "Gibraltar Pound"],
  ["GMD", "Gambian Dalasi"], ["GNF", "Guinean Franc"], ["GTQ", "Guatemalan Quetzal"],
  ["GYD", "Guyanese Dollar"], ["HKD", "Hong Kong Dollar"], ["HNL", "Honduran Lempira"],
  ["HRK", "Croatian Kuna"], ["HTG", "Haitian Gourde"], ["HUF", "Hungarian Forint"],
  ["IDR", "Indonesian Rupiah"], ["ILS", "Israeli New Shekel"], ["INR", "Indian Rupee"],
  ["IQD", "Iraqi Dinar"], ["IRR", "Iranian Rial"], ["ISK", "Icelandic Króna"],
  ["JMD", "Jamaican Dollar"], ["JOD", "Jordanian Dinar"], ["JPY", "Japanese Yen"],
  ["KES", "Kenyan Shilling"], ["KGS", "Kyrgyzstani Som"], ["KHR", "Cambodian Riel"],
  ["KMF", "Comorian Franc"], ["KRW", "South Korean Won"], ["KWD", "Kuwaiti Dinar"],
  ["KYD", "Cayman Islands Dollar"], ["KZT", "Kazakhstani Tenge"], ["LAK", "Lao Kip"],
  ["LBP", "Lebanese Pound"], ["LKR", "Sri Lankan Rupee"], ["LRD", "Liberian Dollar"],
  ["LSL", "Lesotho Loti"], ["LYD", "Libyan Dinar"], ["MAD", "Moroccan Dirham"],
  ["MDL", "Moldovan Leu"], ["MGA", "Malagasy Ariary"], ["MKD", "Macedonian Denar"],
  ["MMK", "Myanmar Kyat"], ["MNT", "Mongolian Tögrög"], ["MOP", "Macanese Pataca"],
  ["MRU", "Mauritanian Ouguiya"], ["MUR", "Mauritian Rupee"], ["MVR", "Maldivian Rufiyaa"],
  ["MWK", "Malawian Kwacha"], ["MXN", "Mexican Peso"], ["MYR", "Malaysian Ringgit"],
  ["MZN", "Mozambican Metical"], ["NAD", "Namibian Dollar"], ["NGN", "Nigerian Naira"],
  ["NIO", "Nicaraguan Córdoba"], ["NOK", "Norwegian Krone"], ["NPR", "Nepalese Rupee"],
  ["NZD", "New Zealand Dollar"], ["OMR", "Omani Rial"], ["PAB", "Panamanian Balboa"],
  ["PEN", "Peruvian Sol"], ["PGK", "Papua New Guinean Kina"], ["PHP", "Philippine Peso"],
  ["PKR", "Pakistani Rupee"], ["PLN", "Polish Złoty"], ["PYG", "Paraguayan Guaraní"],
  ["QAR", "Qatari Riyal"], ["RON", "Romanian Leu"], ["RSD", "Serbian Dinar"],
  ["RUB", "Russian Ruble"], ["RWF", "Rwandan Franc"], ["SAR", "Saudi Riyal"],
  ["SBD", "Solomon Islands Dollar"], ["SCR", "Seychellois Rupee"], ["SDG", "Sudanese Pound"],
  ["SEK", "Swedish Krona"], ["SGD", "Singapore Dollar"], ["SHP", "Saint Helena Pound"],
  ["SLE", "Sierra Leonean Leone"], ["SOS", "Somali Shilling"], ["SRD", "Surinamese Dollar"],
  ["SSP", "South Sudanese Pound"], ["STN", "São Tomé and Príncipe Dobra"], ["SVC", "Salvadoran Colón"],
  ["SYP", "Syrian Pound"], ["SZL", "Swazi Lilangeni"], ["THB", "Thai Baht"],
  ["TJS", "Tajikistani Somoni"], ["TMT", "Turkmenistani Manat"], ["TND", "Tunisian Dinar"],
  ["TOP", "Tongan Paʻanga"], ["TRY", "Turkish Lira"], ["TTD", "Trinidad and Tobago Dollar"],
  ["TWD", "New Taiwan Dollar"], ["TZS", "Tanzanian Shilling"], ["UAH", "Ukrainian Hryvnia"],
  ["UGX", "Ugandan Shilling"], ["UYU", "Uruguayan Peso"], ["UZS", "Uzbekistani Som"],
  ["VED", "Venezuelan Bolívar"], ["VND", "Vietnamese Đồng"], ["VUV", "Vanuatu Vatu"],
  ["WST", "Samoan Tālā"], ["XAF", "Central African CFA Franc"], ["XCD", "East Caribbean Dollar"],
  ["XOF", "West African CFA Franc"], ["XPF", "CFP Franc"], ["YER", "Yemeni Rial"],
  ["ZMW", "Zambian Kwacha"], ["ZWL", "Zimbabwean Dollar"],
];

// Just the 3-letter codes, for simple selects.
export const CURRENCY_CODES = CURRENCIES.map(([code]) => code);
